var _path, _path2, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 21h20v1H2zM3 13h3v8H3zM8 15h3v6H8zM13 11h3v10h-3zM18 8h3v13h-3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.6,
  d: "m4.5 7 4.894 3.426a.2.2 0 0 0 .217.007L19.5 4.5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 7,
  r: 1.5,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 10.5,
  r: 1.5,
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 7.5,
  r: 1.5,
  fill: "currentColor"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 4.5,
  r: 1.5,
  fill: "currentColor"
})));
export default SvgBet;